<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Notifications" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					<g id="ico-notifications" transform="translate(1.76, 0)" :fill="color" fill-rule="nonzero">
						<path d="M35.9822221,26.84 L35.9822221,22.66 C35.9822221,15.18 30.8097779,8.58 23.3884445,7.04 L24.0631111,4.4 C24.5128889,2.2 22.7137779,0 20.24,0 C17.7662221,0 16.192,1.98 16.4168889,4.4 L16.8666666,7.04 C9.89511111,8.36 4.49777779,14.52 4.49777779,22 L4.49777779,26.84 C4.49777779,30.8 2.92355555,34.54 0,37.4 L0,39.6 L15.0675556,39.6 C15.0675556,42.02 17.0915555,44 19.5653334,44 C22.0391111,44 24.0631111,42.02 24.0631111,39.6 L40.48,39.6 L40.48,37.4 C37.5564445,34.54 35.9822221,30.8 35.9822221,26.84 Z M29.2355555,24.86 C28.1111111,24.86 26.9866666,23.76 26.9866666,22.66 C26.9866666,18.7 24.0631111,15.4 20.4648889,15.4 L20.24,15.4 C18.8906666,15.4 17.9911111,14.3 17.9911111,13.2 C17.9911111,12.1 19.1155555,11 20.24,11 L20.4648889,11 C26.5368889,11.22 31.4844445,16.28 31.4844445,22.66 C31.4844445,23.98 30.36,24.86 29.2355555,24.86 Z" id="path-1"></path>
					</g>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>